export const environment = {
  baseEndpoint: 'https://api-qa.talkingstick.app/manager/',
  buildNumber: "29880744",  
  versionNumber: "3.4.3",  
  environment_deploy: 'qa',
  rayGunKey: 'o8ZvYYvyIkeYqwMB9tjiwA',
  authKey: '164ffb3a-0827-4dcb-952a-ab4690a6bc46',
  cryptoKey: '7ae12ce3-31bb-43eb-92d1-c50506c658cb',
  hostname: '',
};
